import { Component } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MetaDataDescriptions } from '../../meta-data/meta-data-descriptions';
import { MatDialogModule } from '@angular/material/dialog';
import { TextButtonComponent } from '../shared/buttons/text-button/text-button.component';
import { FilledButtonComponent } from '../shared/buttons/filled-button/filled-button.component';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { LoaderComponent } from "../shared/loader/loader.component";
import { ModalViewModelInterface, UICommandInterface, UIResultCommandInterface } from '@nts/std/interfaces';
import { BaseModalContainerComponent } from './base-modal-container.component';
import { Observable } from 'rxjs';
import { MessageButton, MessageResult } from '@nts/std/types';

@UntilDestroy()
@Component({
    selector: 'nts-modal-container',
    templateUrl: 'modal-container.component.html',
    styleUrls: ['modal-container.component.scss'],
    standalone: true,
    imports: [
        MatDialogModule,
        TextButtonComponent,
        FilledButtonComponent,
        AsyncPipe,
        NgFor,
        NgIf,
        CdkDrag,
        CdkDragHandle,
        LoaderComponent
    ]
})
export class ModalContainerComponent extends BaseModalContainerComponent {

    override untilDestroyed<T>(instance: T, destroyMethodName?: keyof T): <U>(source: Observable<U>) => Observable<U> {
        return untilDestroyed(this);
    }

    async showStandardModalAsync(
        modalButtons: MessageButton,
        title: string,
        viewModel: ModalViewModelInterface<any, any>,
        metaDataDescriptionsButtons: MetaDataDescriptions[] = []
    ): Promise<MessageResult> {
        viewModel.modalCommands = this.generateFromMessageButton(modalButtons, metaDataDescriptionsButtons);
        viewModel.modalTitle = title;
        const result = await this.createComponent(viewModel, false);
        return result.result;
    }

    private generateFromMessageButton(
        modalButtons: MessageButton,
        metaDataDescriptionsButtons: MetaDataDescriptions[] = []
    ): Array<UICommandInterface> {
        const res = new Array<UIResultCommandInterface<MessageResult>>();
        switch (modalButtons) {
            case MessageButton.Ok:
                res.push(this.createButton(MessageResult.Ok, true, metaDataDescriptionsButtons?.length > 0 ? metaDataDescriptionsButtons[0] : null));
                break;
            case MessageButton.OkCancel:
                res.push(this.createButton(MessageResult.Ok, true, metaDataDescriptionsButtons?.length > 0 ? metaDataDescriptionsButtons[0] : null));
                res.push(this.createButton(MessageResult.Cancel, false, metaDataDescriptionsButtons?.length > 1 ? metaDataDescriptionsButtons[1] : null));
                break;
            case MessageButton.YesNo:
                res.push(this.createButton(MessageResult.Yes, true, metaDataDescriptionsButtons?.length > 0 ? metaDataDescriptionsButtons[0] : null));
                res.push(this.createButton(MessageResult.No, false, metaDataDescriptionsButtons?.length > 1 ? metaDataDescriptionsButtons[1] : null));
                break;
            case MessageButton.YesNoCancel:
                res.push(this.createButton(MessageResult.Yes, true, metaDataDescriptionsButtons?.length > 0 ? metaDataDescriptionsButtons[0] : null));
                res.push(this.createButton(MessageResult.No, false, metaDataDescriptionsButtons?.length > 1 ? metaDataDescriptionsButtons[1] : null));
                res.push(this.createButton(MessageResult.Cancel, false, metaDataDescriptionsButtons?.length > 2 ? metaDataDescriptionsButtons[2] : null));
                break;
        }

        return res;
    }
}
